module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<input type="text" class="url full-width" placeholder="http://example.com"/>\n<select class="target form-control"></select>\n<div class="alt-text-region">\n    <label>Alt text for email:</label>\n    <input type="text" class="alt-text full-width" placeholder=""/>\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/link/LinkActionPropertiesView.tpl
// module id = 1714
// module chunks = 0